import { pcRequest } from '@locallife/biz-request/lib/module/pc';


interface responseCode {
  status: number;
  error_msg: string;
  errorMsg: string;
  message: string;
}

/** 本地生活统一请求库 */
export const request = pcRequest({  }, {
  // logger,
  // NEW 新增 可以定义对接口的通用结果校验
  // responseVerify(response: responseCode) {
  //   if (response?.status === 1) {
  //   		return true
  //   }
  //   return response?.error_msg||response?.errorMsg||response?.message||'请求失败'
	// }
});

